import styles from './branchStockTables.module.css'
import { Branch, useBranchLoaders, useManagerHooks } from '../../../manager'
import { LotsStockTable } from '../lots-stock-table/lotsStockTable'
import { useEffect, useState } from 'react'
import { useStockLoaders } from '../../loaders/stockLoaders'

type Props = {
    productId: string
}

export const BranchStockTables = (props: Props) => {
    const { productId } = props
    
    const { currentBranchId } = useManagerHooks()

    const [stockedBranches, setStockedBranches] = useState<Branch[]>([])

    const branchLoaders = useBranchLoaders()
    const stockLoaders = useStockLoaders()

    const loadStockedBranches = async () => {
        const { findAllBranches } = branchLoaders()
        const branches = findAllBranches()
        const { loadProductStocks } = stockLoaders()
        const productStocks = await loadProductStocks(productId)

        return branches
            .filter(branch => {
                const branchStocks = productStocks.filter(stock => stock.branchId === branch.id)
                const totalUnits = branchStocks.reduce((sum, stock) => sum + stock.availableUnits + stock.reservedUnits, 0)
                return branch.id === currentBranchId || !!totalUnits
            })
            .sort(stock => stock.id !== currentBranchId ? 1 : -1)
    }

    useEffect(() => {
        loadStockedBranches().then(setStockedBranches)
    }, [productId, currentBranchId])
    
    return (
        <div className={styles.container}>
            {stockedBranches.map(branch => (
                <div key={branch.code} className={styles.lotContainer}>
                    <span>{branch.name}:</span>
                    <LotsStockTable
                        productId={productId}
                        branchId={branch.id}
                        className={styles.table}
                    />
                </div>
            ))}
        </div>
    )
}
